import { OPTION_A_OPTION_B_SPREAD_DEFINITION } from './core.js';
import { createSpreadDefinition } from '../internal/builders.js';
export const DECISIONE_CRITICA_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'decisione-critica',
    name: 'Decisione Critica',
    slug: 'decisione-critica',
    category: 'special',
    description: 'Cinque carte per quando la scelta ha peso reale e richiede chiarezza non cosmetica.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['decision', 'clarity'],
    semantic_tags: ['decision', 'diagnostic', 'causal'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'situation', description: 'Qual è il centro reale della decisione?' },
        { role_id: 'obstacle', description: 'Che cosa rende la scelta opaca o difficile?' },
        { role_id: 'resource', description: 'Quale forza può orientarti con più lucidità?' },
        { role_id: 'action', description: 'Quale azione concreta ha maggiore coerenza?' },
        { role_id: 'outcome', description: 'Che cosa si consolida se scegli questa direzione?' },
    ],
    keywords: ['decisione', 'critico', 'bivio', 'lucidità'],
    recommended_for_questions: [
        'Quale decisione ha più integrità, non solo più comodità?',
        'Che cosa sto evitando di vedere prima di scegliere?',
    ],
    contraindications: ['Non ideale se il nodo è ancora prematuro e la situazione non è definita.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const THREE_PATHS_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'three-paths',
    name: 'Three Paths',
    slug: 'three-paths',
    category: 'special',
    description: 'Confronto fra tre possibili linee di sviluppo con esito sintetico finale.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['decision', 'timeline'],
    semantic_tags: ['decision', 'forecast'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'option_a', description: 'Che qualità ha il primo sentiero?' },
        { role_id: 'option_b', description: 'Che qualità ha il secondo sentiero?' },
        { role_id: 'option_c', description: 'Che qualità ha il terzo sentiero?' },
        { role_id: 'advice', description: 'Quale criterio dovrebbe guidare la valutazione?' },
        { role_id: 'outcome', description: 'Quale direzione appare più coerente nel complesso?' },
    ],
    keywords: ['tre vie', 'alternative', 'confronto', 'scelta'],
    recommended_for_questions: [
        'Ho più di due strade possibili e non voglio ridurre troppo presto il quadro.',
        'Quale traiettoria merita davvero energia?',
    ],
    contraindications: ['Non ideale per scelte emotive già chiuse o per letture quotidiane.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const CAUSA_NODO_SCELTA_COSTO_ESITO_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'causa-nodo-scelta-costo-esito',
    name: 'Causa / Nodo / Scelta / Costo / Esito',
    slug: 'causa-nodo-scelta-costo-esito',
    category: 'special',
    description: 'Schema causale per comprendere origine, attrito, scelta, prezzo e risultato.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['decision', 'timeline'],
    semantic_tags: ['decision', 'causal', 'forecast'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'past', name: 'Causa', description: 'Quale causa o antecedente ha creato questo nodo?' },
        { role_id: 'challenge', name: 'Nodo', description: 'Dove si stringe il punto critico?' },
        { role_id: 'action', name: 'Scelta', description: 'Quale scelta è davvero sul tavolo?' },
        { role_id: 'cost', name: 'Costo', description: 'Quale prezzo richiede questa direzione?' },
        { role_id: 'outcome', name: 'Esito', description: 'Quale forma prende il campo dopo la scelta?' },
    ],
    keywords: ['causa', 'nodo', 'costo', 'esito'],
    recommended_for_questions: [
        'Da dove nasce davvero questo bivio?',
        'Quale prezzo sto sottovalutando nella decisione?',
    ],
    contraindications: ['Non ideale per domande relazionali senza una scelta reale in gioco.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const DECISION_SPREAD_DEFINITIONS = [
    OPTION_A_OPTION_B_SPREAD_DEFINITION,
    DECISIONE_CRITICA_SPREAD_DEFINITION,
    THREE_PATHS_SPREAD_DEFINITION,
    CAUSA_NODO_SCELTA_COSTO_ESITO_SPREAD_DEFINITION,
];
//# sourceMappingURL=decision.js.map